<template>
  <div class="backToTop" @click="backToTop"></div>
</template>

<script>
export default {
  methods: {
    backToTop() {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.backToTop {
  width: 53px;
  height: 53px;
  background: #c2d2ea;
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_backToTop.png") no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #3a61b1;
  position: fixed;
  top:0;
  margin: auto;
  bottom: 0;
  right: 0;
  cursor: pointer;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/BackToTop.vue